"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8854],{

/***/ 46523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ Box; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86872);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _helpers_analytics__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60368);
/* harmony import */ var _helpers_tokens__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61274);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);







var BaseBox = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_2__.styled)(_tamagui_core__WEBPACK_IMPORTED_MODULE_2__.View, {
    name: "Box",
    tag: "div",
    variants: {
        shadow: function(shadowToken) {
            return (0,_helpers_tokens__WEBPACK_IMPORTED_MODULE_3__/* .getShadowProps */ .dh)(shadowToken);
        }
    }
}), Box = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function(_param, ref) {
    var analyticsName = _param.analyticsName, _trackImpression = _param.trackImpression, trackImpression = _trackImpression === void 0 ? !1 : _trackImpression, inViewThreshold = _param.inViewThreshold, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "analyticsName",
        "trackImpression",
        "inViewThreshold"
    ]);
    var BaseBoxWithProps = /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BaseBox, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        ref: ref
    }, props));
    return analyticsName && trackImpression ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_helpers_analytics__WEBPACK_IMPORTED_MODULE_6__/* .ComponentWithViewTracking */ .o, {
        Component: BaseBoxWithProps,
        analyticsName: analyticsName,
        eventName: "boxViewEvent",
        inViewThreshold: inViewThreshold,
        ref: ref
    }) : BaseBoxWithProps;
});



/***/ }),

/***/ 12554:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ls": function() { return /* binding */ getRGBA; }
/* harmony export */ });
/* unused harmony exports getB, getG, getR, getRGB, hex, shortToLongHex */
var hex = function(x) {
    return x.toString(16).length === 1 ? "0" + x.toString(16) : x.toString(16);
}, shortToLongHex = function(hex2) {
    var r = hex2.substring(1, 2), g = hex2.substring(2, 3), b = hex2.substring(3);
    return "#".concat(r).concat(r).concat(g).concat(g).concat(b).concat(b);
}, getR = function(c) {
    return parseInt(c.substring(1, 3), 16);
}, getG = function(c) {
    return parseInt(c.substring(3, 5), 16);
}, getB = function(c) {
    return parseInt(c.substring(5), 16);
}, getRGB = function(hex2) {
    return hex2.length === 4 && (hex2 = shortToLongHex(hex2)), "rgb(".concat(getR(hex2), ", ").concat(getG(hex2), ", ").concat(getB(hex2), ")");
}, getRGBA = function(hex2, opacity) {
    return hex2.length === 4 && (hex2 = shortToLongHex(hex2)), "rgba(".concat(getR(hex2), ", ").concat(getG(hex2), ", ").concat(getB(hex2), ", ").concat(opacity, ")");
};



/***/ }),

/***/ 61274:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GJ": function() { return /* binding */ getStateTokenValue; },
/* harmony export */   "Re": function() { return /* binding */ getPercentageTokenValue; },
/* harmony export */   "dh": function() { return /* binding */ getShadowProps; },
/* harmony export */   "vs": function() { return /* binding */ getOpacityTokenValue; }
/* harmony export */ });
/* unused harmony exports getRadiusTokenValue, getSizeTokenValue, getSpaceTokenValue */
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86872);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _convertColor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12554);


var getRadiusTokenValue = function(radiusToken) {
    return getTokens().radius[radiusToken].val;
}, getSizeTokenValue = function(sizeToken) {
    return getTokens().size[sizeToken].val;
}, getSpaceTokenValue = function(spaceToken) {
    return getTokens().space[spaceToken].val;
}, getOpacityTokenValue = function(opacityToken) {
    return (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_0__.getTokens)().opacity[opacityToken].val;
}, getStateTokenValue = function(stateToken) {
    return (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_0__.getTokens)().state[stateToken].val;
}, getShadowProps = function(shadowToken) {
    var tokens = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_0__.getTokens)(), shadowOpacity = tokens.shadowOpacity[shadowToken].val;
    return {
        shadowColor: _tamagui_core__WEBPACK_IMPORTED_MODULE_0__.isWeb ? (0,_convertColor__WEBPACK_IMPORTED_MODULE_1__/* .getRGBA */ .ls)((0,_tamagui_core__WEBPACK_IMPORTED_MODULE_0__.getTokenValue)(shadowToken, "color"), shadowOpacity) : shadowToken,
        shadowOpacity: shadowOpacity,
        shadowOffset: {
            width: tokens.shadowOffsetWidth[shadowToken].val,
            height: tokens.shadowOffsetHeight[shadowToken].val
        },
        shadowRadius: tokens.shadowRadius[shadowToken].val,
        elevationAndroid: tokens.elevation[shadowToken].val
    };
}, getPercentageTokenValue = function(percentageToken) {
    return (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_0__.getTokens)().percentages[percentageToken].val;
};



/***/ }),

/***/ 94801:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CtaInput; }
/* harmony export */ });
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41817);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32165);
/* harmony import */ var core_js_modules_es_symbol_to_primitive_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96649);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57327);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89554);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91038);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82772);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47042);
/* harmony import */ var core_js_modules_es_date_to_primitive_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(96078);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(68309);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9653);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(19601);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(33321);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(69070);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(38880);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(49337);
/* harmony import */ var core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(30489);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(47941);
/* harmony import */ var core_js_modules_es_object_set_prototype_of_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(68304);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(12419);
/* harmony import */ var core_js_modules_es_reflect_to_string_tag_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(81299);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(74916);
/* harmony import */ var core_js_modules_es_regexp_test_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(77601);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(39714);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(78783);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(33948);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(92222);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(67294);
/* harmony import */ var _core_index_mjs__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(8013);
/* harmony import */ var _core_index_mjs__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(4796);
/* harmony import */ var _core_index_mjs__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(26029);
/* harmony import */ var _core_index_mjs__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(93298);
/* harmony import */ var _core_index_mjs__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(49154);
/* harmony import */ var _core_Input_index_mjs__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(16937);
/* harmony import */ var _core_Input_index_mjs__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(32960);
/* harmony import */ var _system_bricks_types_mjs__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(26153);
/* harmony import */ var _system_hidden_mjs__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(10007);
/* harmony import */ var _shared_mjs__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(96768);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }






























var _excluded = ["prefillBehavior"];
function cov_12hwueqay6() {
  var path = "/__w/code/code/js/packages/bricks/src/complex/CtaInput/CtaInput.tsx";
  var hash = "1860a5f6d48768bdd99cff7ccd36bb028ace23f6";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/complex/CtaInput/CtaInput.tsx",
    statementMap: {
      "0": {
        start: {
          line: 11,
          column: 28
        },
        end: {
          line: 11,
          column: 66
        }
      },
      "1": {
        start: {
          line: 12,
          column: 28
        },
        end: {
          line: 12,
          column: 73
        }
      },
      "2": {
        start: {
          line: 14,
          column: 50
        },
        end: {
          line: 103,
          column: 1
        }
      },
      "3": {
        start: {
          line: 32,
          column: 40
        },
        end: {
          line: 32,
          column: 89
        }
      },
      "4": {
        start: {
          line: 34,
          column: 2
        },
        end: {
          line: 57,
          column: 3
        }
      },
      "5": {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 56,
          column: 6
        }
      },
      "6": {
        start: {
          line: 45,
          column: 12
        },
        end: {
          line: 45,
          column: 34
        }
      },
      "7": {
        start: {
          line: 59,
          column: 2
        },
        end: {
          line: 102,
          column: 3
        }
      },
      "8": {
        start: {
          line: 62,
          column: 6
        },
        end: {
          line: 77,
          column: 8
        }
      },
      "9": {
        start: {
          line: 71,
          column: 40
        },
        end: {
          line: 71,
          column: 64
        }
      },
      "10": {
        start: {
          line: 79,
          column: 6
        },
        end: {
          line: 101,
          column: 8
        }
      },
      "11": {
        start: {
          line: 106,
          column: 48
        },
        end: {
          line: 135,
          column: 3
        }
      },
      "12": {
        start: {
          line: 152,
          column: 8
        },
        end: {
          line: 152,
          column: 18
        }
      },
      "13": {
        start: {
          line: 154,
          column: 27
        },
        end: {
          line: 154,
          column: 77
        }
      },
      "14": {
        start: {
          line: 156,
          column: 4
        },
        end: {
          line: 196,
          column: 6
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 14,
            column: 50
          },
          end: {
            line: 14,
            column: 51
          }
        },
        loc: {
          start: {
            line: 31,
            column: 6
          },
          end: {
            line: 103,
            column: 1
          }
        },
        line: 31
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 44,
            column: 19
          },
          end: {
            line: 44,
            column: 20
          }
        },
        loc: {
          start: {
            line: 44,
            column: 25
          },
          end: {
            line: 46,
            column: 11
          }
        },
        line: 44
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 71,
            column: 20
          },
          end: {
            line: 71,
            column: 21
          }
        },
        loc: {
          start: {
            line: 71,
            column: 40
          },
          end: {
            line: 71,
            column: 64
          }
        },
        line: 71
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 111,
            column: 14
          },
          end: {
            line: 111,
            column: 15
          }
        },
        loc: {
          start: {
            line: 111,
            column: 20
          },
          end: {
            line: 111,
            column: 22
          }
        },
        line: 111
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 112,
            column: 15
          },
          end: {
            line: 112,
            column: 16
          }
        },
        loc: {
          start: {
            line: 112,
            column: 21
          },
          end: {
            line: 112,
            column: 23
          }
        },
        line: 112
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 113,
            column: 14
          },
          end: {
            line: 113,
            column: 15
          }
        },
        loc: {
          start: {
            line: 113,
            column: 20
          },
          end: {
            line: 113,
            column: 22
          }
        },
        line: 113
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 114,
            column: 13
          },
          end: {
            line: 114,
            column: 14
          }
        },
        loc: {
          start: {
            line: 114,
            column: 19
          },
          end: {
            line: 114,
            column: 21
          }
        },
        line: 114
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 115,
            column: 12
          },
          end: {
            line: 115,
            column: 13
          }
        },
        loc: {
          start: {
            line: 115,
            column: 18
          },
          end: {
            line: 115,
            column: 20
          }
        },
        line: 115
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 137,
            column: 2
          },
          end: {
            line: 137,
            column: 3
          }
        },
        loc: {
          start: {
            line: 137,
            column: 18
          },
          end: {
            line: 197,
            column: 3
          }
        },
        line: 137
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 34,
            column: 2
          },
          end: {
            line: 57,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 34,
            column: 2
          },
          end: {
            line: 57,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 34
      },
      "1": {
        loc: {
          start: {
            line: 52,
            column: 13
          },
          end: {
            line: 52,
            column: 81
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 52,
            column: 13
          },
          end: {
            line: 52,
            column: 38
          }
        }, {
          start: {
            line: 52,
            column: 42
          },
          end: {
            line: 52,
            column: 81
          }
        }],
        line: 52
      },
      "2": {
        loc: {
          start: {
            line: 59,
            column: 2
          },
          end: {
            line: 102,
            column: 3
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 60,
            column: 4
          },
          end: {
            line: 60,
            column: 15
          }
        }, {
          start: {
            line: 61,
            column: 4
          },
          end: {
            line: 77,
            column: 8
          }
        }, {
          start: {
            line: 78,
            column: 4
          },
          end: {
            line: 101,
            column: 8
          }
        }],
        line: 59
      },
      "3": {
        loc: {
          start: {
            line: 68,
            column: 24
          },
          end: {
            line: 68,
            column: 87
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 68,
            column: 46
          },
          end: {
            line: 68,
            column: 65
          }
        }, {
          start: {
            line: 68,
            column: 68
          },
          end: {
            line: 68,
            column: 87
          }
        }],
        line: 68
      },
      "4": {
        loc: {
          start: {
            line: 69,
            column: 21
          },
          end: {
            line: 69,
            column: 58
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 69,
            column: 45
          },
          end: {
            line: 69,
            column: 46
          }
        }, {
          start: {
            line: 69,
            column: 49
          },
          end: {
            line: 69,
            column: 58
          }
        }],
        line: 69
      },
      "5": {
        loc: {
          start: {
            line: 80,
            column: 64
          },
          end: {
            line: 80,
            column: 97
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 80,
            column: 81
          },
          end: {
            line: 80,
            column: 87
          }
        }, {
          start: {
            line: 80,
            column: 90
          },
          end: {
            line: 80,
            column: 97
          }
        }],
        line: 80
      },
      "6": {
        loc: {
          start: {
            line: 181,
            column: 27
          },
          end: {
            line: 181,
            column: 78
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 181,
            column: 68
          },
          end: {
            line: 181,
            column: 74
          }
        }, {
          start: {
            line: 181,
            column: 77
          },
          end: {
            line: 181,
            column: 78
          }
        }],
        line: 181
      },
      "7": {
        loc: {
          start: {
            line: 188,
            column: 21
          },
          end: {
            line: 188,
            column: 80
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 188,
            column: 21
          },
          end: {
            line: 188,
            column: 51
          }
        }, {
          start: {
            line: 188,
            column: 55
          },
          end: {
            line: 188,
            column: 80
          }
        }],
        line: 188
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "1860a5f6d48768bdd99cff7ccd36bb028ace23f6"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_12hwueqay6 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_12hwueqay6();
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
// Similar to the CtaInputLite component, difference is that this component
// uses the <Input /> component, which is a very heavy dependency.






var INVALID_EMAIL_ERROR = (cov_12hwueqay6().s[0]++, "Looks like this isn't a valid email.");
var INVALID_PHONE_ERROR = (cov_12hwueqay6().s[1]++, "Looks like this isn't a valid phone number.");
cov_12hwueqay6().s[2]++;
var InputWrapperWithPrefill = function InputWrapperWithPrefill(_ref) {
  var ariaLabel = _ref.ariaLabel,
    ariaLabelledby = _ref.ariaLabelledby,
    inputType = _ref.inputType,
    placeholderText = _ref.placeholderText,
    value = _ref.value,
    autoComplete = _ref.autoComplete,
    autoFocus = _ref.autoFocus,
    _onChange = _ref.onChange,
    onKeyDown = _ref.onKeyDown,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    unboundedWidth = _ref.unboundedWidth,
    designStyle = _ref.designStyle,
    className = _ref.className,
    analyticsName = _ref.analyticsName,
    prefillBehavior = _ref.ctaProps.prefillBehavior;
  cov_12hwueqay6().f[0]++;
  var _ref2 = (cov_12hwueqay6().s[3]++, react__WEBPACK_IMPORTED_MODULE_31__.useState(Boolean(prefillBehavior))),
    _ref3 = _slicedToArray(_ref2, 2),
    showPrefill = _ref3[0],
    setShowPrefill = _ref3[1];
  cov_12hwueqay6().s[4]++;
  if (showPrefill) {
    cov_12hwueqay6().b[0][0]++;
    cov_12hwueqay6().s[5]++;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_31__.createElement(_core_index_mjs__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_31__.createElement(_core_index_mjs__WEBPACK_IMPORTED_MODULE_33__/* ["default"] */ .Z, {
      fontWeight: 'semibold'
    }, value), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_31__.createElement(_core_index_mjs__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .ZP, {
      "aria-label": "Edit input text",
      variant: "inline-link",
      textDecoration: "none",
      analyticsName: "prefill-edit-text",
      type: "button",
      onClick: function onClick() {
        cov_12hwueqay6().f[1]++;
        cov_12hwueqay6().s[6]++;
        setShowPrefill(false);
      }
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_31__.createElement(_core_index_mjs__WEBPACK_IMPORTED_MODULE_35__/* ["default"] */ .Z, {
      alignItems: 'center',
      gap: "2",
      justifyContent: "center"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_31__.createElement(_core_index_mjs__WEBPACK_IMPORTED_MODULE_33__/* ["default"] */ .Z, _extends({}, prefillBehavior.textProps, {
      textAlign: "center"
    }), prefillBehavior.editCtaText), (cov_12hwueqay6().b[1][0]++, prefillBehavior.iconProps) && (cov_12hwueqay6().b[1][1]++, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_31__.createElement(_core_index_mjs__WEBPACK_IMPORTED_MODULE_36__/* ["default"] */ .Z, prefillBehavior.iconProps)))));
  } else {
    cov_12hwueqay6().b[0][1]++;
  }
  cov_12hwueqay6().s[7]++;
  switch (inputType) {
    case 'tel':
      cov_12hwueqay6().b[2][0]++;
    case 'email':
      cov_12hwueqay6().b[2][1]++;
      cov_12hwueqay6().s[8]++;
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_31__.createElement(_core_Input_index_mjs__WEBPACK_IMPORTED_MODULE_37__/* ["default"] */ .ZP, {
        analyticsName: analyticsName,
        id: inputType,
        type: inputType,
        value: value,
        errorMessage: inputType === 'tel' ? (cov_12hwueqay6().b[3][0]++, INVALID_PHONE_ERROR) : (cov_12hwueqay6().b[3][1]++, INVALID_EMAIL_ERROR),
        minLength: inputType === 'email' ? (cov_12hwueqay6().b[4][0]++, 1) : (cov_12hwueqay6().b[4][1]++, undefined),
        name: inputType,
        onChange: function onChange(event) {
          cov_12hwueqay6().f[2]++;
          cov_12hwueqay6().s[9]++;
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }
          return _onChange.apply(void 0, [event].concat(args));
        },
        placeholder: placeholderText,
        unboundedWidth: unboundedWidth,
        borderRadius: designStyle,
        "aria-label": ariaLabel
      });
    default:
      cov_12hwueqay6().b[2][2]++;
      cov_12hwueqay6().s[10]++;
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_31__.createElement(_core_index_mjs__WEBPACK_IMPORTED_MODULE_35__/* ["default"] */ .Z, {
        className: "input-container",
        width: ['100%', null, unboundedWidth ? (cov_12hwueqay6().b[5][0]++, '100%') : (cov_12hwueqay6().b[5][1]++, '350px')]
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_31__.createElement(_core_Input_index_mjs__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .Z, {
        name: "CtaInput",
        className: "cta-input-control cta-input-js ".concat(className),
        onFocus: onFocus,
        onBlur: onBlur,
        type: inputType,
        value: value,
        onChange: _onChange,
        onKeyDown: onKeyDown,
        placeholder: placeholderText,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        required: true,
        borderRadius: designStyle,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledby,
        analyticsName: analyticsName,
        height: "56px"
      }));
  }
};
var CtaInput = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(CtaInput, _React$PureComponent);
  function CtaInput() {
    _classCallCheck(this, CtaInput);
    return _callSuper(this, CtaInput, arguments);
  }
  _createClass(CtaInput, [{
    key: "render",
    value: function render() {
      var _ref5;
      cov_12hwueqay6().f[8]++;
      var _ref4 = (cov_12hwueqay6().s[12]++, this.props),
        onSubmit = _ref4.onSubmit,
        paddingLevel = _ref4.paddingLevel,
        showBorder = _ref4.showBorder,
        showShadow = _ref4.showShadow,
        unboundedWidth = _ref4.unboundedWidth,
        designStyle = _ref4.designStyle,
        failure = _ref4.failure,
        analyticsName = _ref4.analyticsName,
        _ref4$ctaProps = _ref4.ctaProps,
        _prefillBehavior = _ref4$ctaProps.prefillBehavior,
        ctaProps = _objectWithoutProperties(_ref4$ctaProps, _excluded);
      var mergedCtaProps = (cov_12hwueqay6().s[13]++, _objectSpread(_objectSpread({}, CtaInput.defaultProps.ctaProps), ctaProps));
      cov_12hwueqay6().s[14]++;
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_31__.createElement(_shared_mjs__WEBPACK_IMPORTED_MODULE_39__/* .CtaInputWrapper */ .B6, {
        className: "od-cta-input",
        unboundedWidth: unboundedWidth
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_31__.createElement(_shared_mjs__WEBPACK_IMPORTED_MODULE_39__/* .Wrapper */ .im, {
        className: "cta-input-wrapper",
        designStyle: designStyle,
        paddingLevel: paddingLevel,
        showBorder: showBorder,
        showShadow: showShadow,
        unboundedWidth: unboundedWidth,
        failure: failure
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_31__.createElement(_shared_mjs__WEBPACK_IMPORTED_MODULE_39__/* .FormWrapper */ .n5, {
        shouldSubmitOnClick: mergedCtaProps.type === 'submit',
        onSubmit: onSubmit
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_31__.createElement(_shared_mjs__WEBPACK_IMPORTED_MODULE_39__/* .InputWrapper */ .SP, {
        unboundedWidth: unboundedWidth,
        designStyle: designStyle
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_31__.createElement(InputWrapperWithPrefill, this.props)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_31__.createElement(_shared_mjs__WEBPACK_IMPORTED_MODULE_39__/* .InputButton */ .Rg, {
        className: "cta-input-button"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_31__.createElement(_core_index_mjs__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .ZP, _extends({
        className: "cta-button",
        analyticsName: "".concat(analyticsName, "-cta-button"),
        onClick: mergedCtaProps.onClick,
        size: mergedCtaProps.size,
        variant: mergedCtaProps.variant,
        type: mergedCtaProps.type,
        loadingText: mergedCtaProps.loadingText,
        loading: mergedCtaProps.loading,
        marginTop: mergedCtaProps.marginType === 'medium' ? (cov_12hwueqay6().b[6][0]++, '10px') : (cov_12hwueqay6().b[6][1]++, 0),
        borderRadius: designStyle
      }, mergedCtaProps), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_31__.createElement(react__WEBPACK_IMPORTED_MODULE_31__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_31__.createElement(_system_bricks_types_mjs__WEBPACK_IMPORTED_MODULE_40__/* .bricks.span */ .G.span, {
        css: _system_hidden_mjs__WEBPACK_IMPORTED_MODULE_41__/* .hiddenXsDown */ .uN
      }, mergedCtaProps.actionText), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_31__.createElement(_system_bricks_types_mjs__WEBPACK_IMPORTED_MODULE_40__/* .bricks.span */ .G.span, {
        css: _system_hidden_mjs__WEBPACK_IMPORTED_MODULE_41__/* .hiddenXsUp */ .dQ
      }, (_ref5 = (cov_12hwueqay6().b[7][0]++, mergedCtaProps.actionTextSmall)) !== null && _ref5 !== void 0 ? _ref5 : (cov_12hwueqay6().b[7][1]++, mergedCtaProps.actionText))))))));
    }
  }]);
  return CtaInput;
}((react__WEBPACK_IMPORTED_MODULE_31__.PureComponent));
_defineProperty(CtaInput, "defaultProps", (cov_12hwueqay6().s[11]++, {
  autoComplete: 'on',
  autoFocus: true,
  className: '',
  designStyle: 'roundedSquare',
  onChange: function onChange() {
    cov_12hwueqay6().f[3]++;
  },
  onKeyDown: function onKeyDown() {
    cov_12hwueqay6().f[4]++;
  },
  onSubmit: function onSubmit() {
    cov_12hwueqay6().f[5]++;
  },
  onFocus: function onFocus() {
    cov_12hwueqay6().f[6]++;
  },
  onBlur: function onBlur() {
    cov_12hwueqay6().f[7]++;
  },
  paddingLevel: 'medium',
  showBorder: true,
  showShadow: false,
  value: '',
  inputType: 'text',
  unboundedWidth: false,
  ctaProps: {
    actionText: 'Go',
    actionTextSmall: 'Go',
    size: 'md',
    'aria-label': 'Input text',
    variant: 'primary',
    type: 'submit',
    disabled: false,
    prefillBehavior: undefined,
    loadingText: 'Loading ...',
    loading: false,
    marginType: 'none'
  }
}));


/***/ }),

/***/ 63282:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* unused harmony export Card */
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41817);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32165);
/* harmony import */ var core_js_modules_es_symbol_to_primitive_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96649);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57327);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89554);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82772);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_date_to_primitive_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96078);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9653);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(19601);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(33321);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69070);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(38880);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(49337);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(47941);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(78783);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(33948);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useObservabilitySafe_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(98352);
/* harmony import */ var _system_utils_index_mjs__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(48189);
/* harmony import */ var _Flex_index_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(93298);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }




















var _excluded = ["analyticsName", "trackImpression", "cardStyle"],
  _excluded2 = ["variant", "clickable", "analyticsName"];
function cov_gid0f43ak() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Card/Card.tsx";
  var hash = "2c75e8ea7c98a5ebfcfd3636399d3e855efcc67b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Card/Card.tsx",
    statementMap: {
      "0": {
        start: {
          line: 38,
          column: 81
        },
        end: {
          line: 53,
          column: 1
        }
      },
      "1": {
        start: {
          line: 44,
          column: 20
        },
        end: {
          line: 44,
          column: 92
        }
      },
      "2": {
        start: {
          line: 45,
          column: 2
        },
        end: {
          line: 52,
          column: 4
        }
      },
      "3": {
        start: {
          line: 130,
          column: 41
        },
        end: {
          line: 142,
          column: 1
        }
      },
      "4": {
        start: {
          line: 131,
          column: 16
        },
        end: {
          line: 131,
          column: 72
        }
      },
      "5": {
        start: {
          line: 132,
          column: 2
        },
        end: {
          line: 134,
          column: 3
        }
      },
      "6": {
        start: {
          line: 133,
          column: 4
        },
        end: {
          line: 133,
          column: 91
        }
      },
      "7": {
        start: {
          line: 135,
          column: 2
        },
        end: {
          line: 141,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 38,
            column: 81
          },
          end: {
            line: 38,
            column: 82
          }
        },
        loc: {
          start: {
            line: 43,
            column: 6
          },
          end: {
            line: 53,
            column: 1
          }
        },
        line: 43
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 130,
            column: 41
          },
          end: {
            line: 130,
            column: 42
          }
        },
        loc: {
          start: {
            line: 130,
            column: 94
          },
          end: {
            line: 142,
            column: 1
          }
        },
        line: 130
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 132,
            column: 2
          },
          end: {
            line: 134,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 132,
            column: 2
          },
          end: {
            line: 134,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 132
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "2c75e8ea7c98a5ebfcfd3636399d3e855efcc67b"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_gid0f43ak = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_gid0f43ak();
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





/**
 * NOTE ABOUT METRIC TRACKING:
 * Card is set up to track impression events
 * It will only track impression events if:
 *  1) a non-empty analyticsName is passed down - Convention: {appName}-{cardName}
 *  2) card enters viewport (threshold is set at 100% for now.  threshold: Number between 0 and 1 indicates the percentage that should be visible before triggering.)
 *
 * Events will be sent to the journey service and will end up in the corresponding tables (e.g. journey_service_production.card_view_event for card impression events)
 * For more information on tracking please refer here: https://opendoor.atlassian.net/wiki/spaces/SELL/pages/1926201404/EDD+User+Behavior+Metrics+in+Bricks
 */
cov_gid0f43ak().s[0]++;
var CardWithTracking = function CardWithTracking(_ref) {
  var analyticsName = _ref.analyticsName,
    trackImpression = _ref.trackImpression,
    cardStyle = _ref.cardStyle,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_gid0f43ak().f[0]++;
  var inViewRef = (cov_gid0f43ak().s[1]++, (0,_hooks_useObservabilitySafe_mjs__WEBPACK_IMPORTED_MODULE_21__/* .useTrackComponentInView */ .O)('cardViewEvent', trackImpression, analyticsName));
  cov_gid0f43ak().s[2]++;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_20__.createElement(_Flex_index_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z
  // __css has a lower priority than sx
  , _extends({
    ref: inViewRef,
    __css: cardStyle
  }, props));
};

/**
 * Cards are containers that are used to bring attention to an action that we
 * want the seller or buyer to take.  We have `Primary`, `Secondary`,
 * `Tertiary`, and `Outline` Cards with different use cases.
 *
 * *   `Primary` Cards should be used only once per page.
 *
 * *   `Secondary` Cards can be used more than once on a page.
 *
 * *   `Tertiary` Cards are used for content groupings and content callouts.
 *
 * *   `Outline` Cards may be used as an alternative to `Tertiary`.
 *
 *
 * Card variant variations
 * ------------------------------------------------------------------------------------------------
 *
 * "primary"
 *
 * "secondary"
 *
 * "tertiary"
 *
 * "outline"
 *
 * Accessibility
 *
 *
 * -----------------
 *
 * ####
 *
 * Clickable Cards
 *
 * Non-interactable elements should not have an `onClick` method. When an
 * element should be clickable, it should be wrapped in a `Button` component
 * with the `ghost` variant. This will ensure that the element is clickable and
 * has a hover state without adding interactive behaviors to the element.
 *
 * ###
 *
 * ✅ Pass
 *
 * <Button variant="ghost" onClick={() => {/* do something *&#47; }}
 * aria-label=""> <Card /> </Button>
 *
 *
 * ###
 *
 * 🛑 Fail
 *
 * <Card onClick={() => {/* do something *&#47; }} />
 *
 *
 * Analytics
 *
 *
 * -------------
 *
 * `Card` is set up to track impression events. It will only track impression
 * events if:
 *
 * 1.  a non-empty `analyticsName` is passed down (convention:
 * {appName}-{cardName})
 *
 * 2.  passing `trackImpression={true}` Card impression events will only be
 * tracked the first time that the card enters the viewport
 *
 *
 * Events will be sent to the journey service and will end up in the
 * corresponding tables (e.g.
 * journey\_service\_production.platform\_card\_view\_event for card impression
 * events). For more information on tracking please refer
 * here:[https://opendoor.atlassian.net/wiki/spaces/CONSUMER/blog/2023/05/10/2304737293/Bricks+Events+Update](https://opendoor.atlassian.net/wiki/spaces/CONSUMER/blog/2023/05/10/2304737293/Bricks+Events+Update)
 */
cov_gid0f43ak().s[3]++;
var Card = function Card(_ref2) {
  var variant = _ref2.variant,
    clickable = _ref2.clickable,
    analyticsName = _ref2.analyticsName,
    props = _objectWithoutProperties(_ref2, _excluded2);
  cov_gid0f43ak().f[1]++;
  var style = (cov_gid0f43ak().s[4]++, (0,_system_utils_index_mjs__WEBPACK_IMPORTED_MODULE_23__/* .useStyleConfig */ .mq)('Card', _objectSpread({
    variant: variant,
    clickable: clickable
  }, props)));
  cov_gid0f43ak().s[5]++;
  if (analyticsName) {
    cov_gid0f43ak().b[0][0]++;
    cov_gid0f43ak().s[6]++;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_20__.createElement(CardWithTracking, _extends({
      cardStyle: style,
      analyticsName: analyticsName
    }, props));
  } else {
    cov_gid0f43ak().b[0][1]++;
  }
  cov_gid0f43ak().s[7]++;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_20__.createElement(_Flex_index_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z
  // __css has a lower priority than sx
  , _extends({
    __css: style
  }, props));
};
/* harmony default export */ __webpack_exports__["C"] = (Card);

/***/ })

}]);